module.exports = __webpack_public_path__ + "static/img/img-textcloud.3951964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-textcloud.png
// module id = gqZM
// module chunks = 1